import { Instance } from 'mobx-state-tree';
import { OrganizationOptimizationPreferencesDtoModelBase } from './OrganizationOptimizationPreferencesDtoModel.base';

/* The TypeScript type of an instance of OrganizationOptimizationPreferencesDtoModel */
export interface OrganizationOptimizationPreferencesDtoModelType extends Instance<typeof OrganizationOptimizationPreferencesDtoModel.Type> {}

/* A graphql query fragment builders for OrganizationOptimizationPreferencesDtoModel */
export {
  selectFromOrganizationOptimizationPreferencesDto,
  organizationOptimizationPreferencesDtoModelPrimitives,
  OrganizationOptimizationPreferencesDtoModelSelector,
} from './OrganizationOptimizationPreferencesDtoModel.base';

/**
 * OrganizationOptimizationPreferencesDtoModel
 */
export const OrganizationOptimizationPreferencesDtoModel = OrganizationOptimizationPreferencesDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
